module.exports = __webpack_public_path__ + "assets/img/Groups978.97039670.png";